module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nqB9x0/tc-custom/9781439677957.jpg?1738410654954",
      "alt": "This image is the cover for the book Ghostly Tales of Dallas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghostly Tales of Dallas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ghost stories from Dallas, Texas have never been so creepy, fun, and full of mystery! Welcome to the spooky streets of Dallas! Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms.  Did you know that the Sammons Center for the Arts is said to have a haunted elevator? Or that sounds of music and laughter sometimes drift up and down the halls of the Adolphus Hotel... even when no one is there? Can you believe the friendly ghost at Catfish Plantation has been known to make coffee for its hosts? Pulled right from history, these ghostly tales will change the way you see Dallas and have you sleeping with the light on!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carie Juettner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("CARIE JUETTNER   was born on Halloween and has loved ghost stories ever since. When she's not writing books, she loves to read, do yoga, and take long walks in the woods. Carie lives in Richardson, Texas, with her husband and pets, but she loves to travel. One of her favorite things to do on vacation is visit cemeteries and learn about local lore. To find out more about Carie, visit her website: cariejuettner.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0